import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  link: {
    color: 'var(--color-coral)',
    fontStyle: 'italic',
    fontWeight: 600,
    '&:hover': {
      color: 'var(--color-coral-deep)',
    },
  },
  divider: {
    margin: '1.5rem 0',
    backgroundColor: 'rgba(61, 30, 92, 0.08)',
  },
  /* shared form heading style */
  formHeading: {
    fontFamily: 'Fraunces, serif',
    fontWeight: 600,
    color: 'var(--color-plum)',
    marginBottom: '1.5rem',
  },
}));
